(ns teamoesterreich.config-base
  (:require [toe-prepare.config])
  )

; NOTE: strange setup explained in teamoesterreich.config

(def raw-config
  (clj->js toe-prepare.config/config))
